<template>
  <div class="menuFrame">
    <loading :active.sync="isLoading"></loading>

    <div id="track">
      <div class="d-flex justify-content-between">
        <div>
          <a href="/ExhibitorServiceTW/">展覽列表</a><span>/</span>
          <em name="Exhibition"></em> <span>/</span>基本資料
        </div>
        <div>
          <span class="bold">登入帳號 :</span>
          <span> {{ UserId }}</span>
        </div>
      </div>
    </div>
    <!-- track end -->
    <!-- article -->
    <article>
      <div class="MbDevice">
        <div class="homeLeft">
          <div class="UserAccount ml-1">
            <span class="bold">登入帳號 :</span>
            <span> {{ UserId }}</span>
          </div>
          <hr />
          <div class="expoLogo"><img :src="ExhLogo" width="100%" /></div>
          <div class="expoInfo">
            <p class="bold" name="Exhibition"></p>
            <p>{{ ExhBegin }} - {{ ExhEnd }}</p>
            <p>{{ ExhVenue }}</p>
          </div>
          <p class="clear"></p>
        </div>
      </div>

      <div class="PcDevice">
        <div class="contentBoxStatus">
          <Dashboard></Dashboard>
        </div>
        <div class="my-3"></div>
      </div>
      <div class="contentBox">
        <div class="MbDevice">
          <Dashboard></Dashboard>
        </div>

        <h1>基本資料</h1>
        <p class="my-3">&nbsp;</p>

        <form
          enctype="multipart/form-data"
          id="form"
          @submit.prevent="updateLogo"
        >
          <input type="hidden" name="RegNo" />

          <div class="proLeft PcDevice">
            <label class="inputFile">
              <div class="mb-3 ImgHoverStyle pointer">
                <img :src="modelSrc" class="img-fluid" />
              </div>
              <p class="my-3">&nbsp;</p>
              <span name="showName" class="nowrap"></span>
              <input
                type="file"
                name="ProImg"
                accept=".jpg,.jpeg,.webp"
                @change="uploadNewImgPC($event)"
              />
              <p class="divider"></p>
              <div class="d-flex justify-content-around">
                <div>
                  <p class="align_c">
                    <span class="btnStyle btnGray">選擇圖片</span>
                  </p>
                </div>
                <div v-if="modelSrc !== OImgSrc">
                  <p class="align_c">
                    <span class="btnStyle btnRed" @click.prevent="resetImg"
                      >重設圖片
                    </span>
                  </p>
                </div>
              </div>
            </label>
            <div class="uploadAlert">
              <p class="italic">檔案大小：最大 3MB</p>
              <p class="italic">檔案限制：JPG、WEBP</p>
              <p class="italic">建議尺寸：最低要求 500 x 500像素</p>
            </div>
          </div>

          <div class="proLeft MbDevice">
            <label class="inputFile pointer">
              <div class="mb-3"><img :src="modelSrc" class="img-fluid" /></div>
              <p class="my-3">&nbsp;</p>
              <span name="showName" class="nowrap"></span>
              <input
                type="file"
                name="ProImg"
                accept=".jpg,.jpeg,.webp"
                @change="uploadNewImgMb($event)"
              />
              <p class="divider"></p>

              <div class="d-flex justify-content-around">
                <div>
                  <p class="align_c">
                    <span class="btnStyle btnGray">選擇圖片</span>
                  </p>
                </div>
                <div v-if="modelSrc !== OImgSrc">
                  <p class="align_c">
                    <span class="btnStyle btnRed" @click.prevent="resetImg"
                      >重設圖片
                    </span>
                  </p>
                </div>
              </div>
            </label>
            <div class="uploadAlert">
              <p class="italic">檔案大小：最大 3MB</p>
              <p class="italic">檔案限制：JPG、WEBP</p>
              <p class="italic">建議尺寸：最低要求 500 x 500像素</p>
            </div>
          </div>

          <!-- left end -->
          <!-- right -->
          <div class="proRight">
            <div class="alert">
              <p>
                若要修改公司基本資訊或更換展覽聯絡人/行銷聯絡人，請<a
                  href="//www.chanchao.com.tw/contact.asp"
                  target="_blank"
                  >聯繫主辦單位</a
                >。
              </p>
              <p class="mt-1">
                以下資料( 公司名稱、展出區域、攤位號碼、展出品牌
                )將露出於官網->參展商列表。
              </p>
            </div>
            <p class="my-3">&nbsp;</p>
            <p class="formTitle">公司名稱</p>
            <p name="Directory_ComName">{{ profileList.Directory_ComName }}</p>
            <p name="Directory_eComName">
              {{ profileList.Directory_eComName }}
            </p>
            <p class="my-3">&nbsp;</p>
            <div class="left">
              <p class="formTitle">展出區域</p>
              <p name="ExhibArea">{{ profileList.ExhibArea }}</p>
            </div>
            <div class="right">
              <p class="formTitle">攤位號碼</p>
              <p name="BoothNo">{{ profileList.BoothNo }}</p>
            </div>
            <p class="clear"></p>
            <p class="my-3">&nbsp;</p>

            <div class="left">
              <p class="formTitle">使用攤位數</p>
              <p name="ExhibArea">{{ profileList.booth_sqm }}</p>
            </div>
            <div class="right">
              <p class="formTitle">攤位型式</p>
              <p name="BoothNo">
                <span v-if="profileList.booth_type == 'A'"> 淨地 </span>
                <span v-else-if="profileList.booth_type == 'B'"> 標攤 </span>
                <span v-else-if="profileList.booth_type == 'C'">
                  標攤 + 淨地
                </span>
              </p>
            </div>

            <p class="clear"></p>
            <p class="my-3">&nbsp;</p>
            <p class="formTitle">展出品牌</p>
            <div v-if="LocalExh">
              <div class="langTip">
                <input
                  type="text"
                  name="BrandName"
                  class="maxText textStyle"
                  maxlength="100"
                  v-model="profileList.BrandName"
                />
                <span>中</span>
              </div>
            </div>
            <p class="divider"></p>
            <div class="langTip">
              <input
                type="text"
                name="eBrandName"
                class="maxText textStyle"
                v-model="profileList.eBrandName"
                maxlength="150"
              />
              <span>EN</span>
            </div>
            <p class="my-3">&nbsp;</p>
            <div class="left">
              <p class="formTitle">展覽聯絡人</p>
              <p class="bold" name="RegContact"></p>
              <p>
                <span class="formContent"> Name : </span
                ><span name="RegTel">{{ profileList.RegContact }}</span>
              </p>
              <p>
                <span class="formContent">Tel :</span>
                <span name="RegTel">{{ profileList.RegTel }}</span>
              </p>
              <p v-if="profileList.RegFax">
                <span class="formContent">Fax :</span>
                <span name="RegFax">{{ profileList.RegFax }}</span>
              </p>
              <p>
                <span class="formContent">Mob :</span>
                <span name="RegMobile">{{ profileList.RegMobile }}</span>
              </p>
              <!-- <p class="divider"></p>
              <div>
                <span class="formContent">Email :</span> <span class="displayBlock" name="RegEmail"></span>
                <div class="mt-1">
                  <ul v-for="item in emailListArray">
                    <li>{{ item }}</li>
                  </ul>
                </div>
              </div> -->
            </div>

            <p class="clear"></p>
          </div>
          <!-- right end -->
          <p class="clear"></p>
          <p class="my-3">&nbsp;</p>
          <div class="align_c">
            <div class="PcDevice text-center">
              <input
                type="Submit"
                value="確定送出"
                class="btn btn-lg btn-primary"
              />
            </div>
            <div class="MbDevice text-center">
              <input type="Submit" value="確定送出" class="btn btn-primary" />
            </div>
          </div>
        </form>

        <!-- 桌機板裁切工具 Modal  -->
        <div id="cropImagePop" class="modal fade" tabindex="-1" role="dialog">
          <div class="modal-dialog modal-xl" role="document">
            <div class="modal-content">
              <div class="modal-header d-flex justify-content-between">
                <div class="modal-title" style="font-size: 25px">
                  <div class="d-flex align-self-center">
                    <div class="mr-3">
                      <img src="../../assets/images/cropImg.png" width="30px" />
                    </div>
                    <div style="font-size: 25px">編輯參展商標圖片</div>
                  </div>
                </div>
                <div
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </div>
              </div>
              <div class="modal-body">
                <div class="row">
                  <div class="col-sm-8">
                    <div class="CropBoxStyle">
                      <vue-cropper
                        ref="cropper"
                        :img="option.img"
                        :output-size="option.size"
                        :output-type="option.outputType"
                        :info="true"
                        :full="option.full"
                        :fixed="fixed"
                        :can-move="option.canMove"
                        :can-move-box="option.canMoveBox"
                        :fixed-box="option.fixedBox"
                        :original="option.original"
                        :auto-crop="option.autoCrop"
                        :auto-crop-width="option.autoCropWidth"
                        :auto-crop-height="option.autoCropHeight"
                        :center-box="option.centerBox"
                        :high="option.high"
                        :max-img-size="option.max"
                        :fixed-number="fixedNumber"
                        :enlarge="option.enlarge"
                        :infoTrue="option.infoTrue"
                        :mode="option.mode"
                        @real-time="realTime"
                      >
                      </vue-cropper>
                    </div>

                    <div class="d-flex justify-content-between mt-3 mx-3">
                      <div>
                        <button @click="rotateLeft" class="btn btn-info">
                          向左旋轉
                        </button>
                        <button @click="rotateRight" class="btn btn-info ml-2">
                          向右旋轉
                        </button>
                        <button
                          @click="changeScale(1)"
                          class="btn btn-info ml-2"
                        >
                          放大
                        </button>
                        <button
                          @click="changeScale(-1)"
                          class="btn btn-info ml-2"
                        >
                          縮小
                        </button>
                      </div>

                      <div>
                        <button
                          @click="refreshCrop"
                          class="btn btn-outline-info ml-5"
                        >
                          重設
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <div :style="previewStyle1" class="cropViewFrame">
                      <div :style="previews.div">
                        <img :src="previews.url" :style="previews.img" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <hr />
              <div class="modal-footer">
                <div>
                  <button
                    type="button"
                    id="cropImageBtn"
                    class="btn btn-lg btn-primary mr-2"
                    @click="OutputPC()"
                  >
                    裁切
                  </button>
                  <button
                    type="button"
                    class="btn btn-lg btn-secondary"
                    data-dismiss="modal"
                  >
                    關閉
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 行動版裁切工具 Modal  -->
        <div
          class="modal fade"
          id="cropperMb"
          tabindex="-1"
          role="dialog"
          aria-labelledby="exampleModalCenterTitle"
          aria-hidden="true"
          data-backdrop="static"
          data-keyboard="false"
        >
          <div
            class="modal-dialog modal-sm modal-dialog-centered"
            role="document"
          >
            <div class="modal-content">
              <div class="modal-body">
                <p>&middot; 系統將自動調整圖片至正方形尺寸。</p>
                <p>&middot; 如有裁切及編輯圖片之需求，請至 PC 裝置上傳圖片。</p>
              </div>

              <div class="modal-footer">
                <button
                  type="button"
                  id="cropperMb"
                  class="btn btn-sm btn-primary"
                  @click="OutputMb()"
                >
                  確定
                </button>
              </div>
            </div>
          </div>
        </div>

        <div v-if="showImg" class="CropBoxStyle">
          <vue-cropper
            ref="cropper"
            :img="option.img"
            :output-size="option.size"
            :output-type="option.outputType"
            :info="true"
            :full="option.full"
            :fixed="fixed"
            :can-move="option.canMove"
            :can-move-box="option.canMoveBox"
            :fixed-box="option.fixedBox"
            :original="option.original"
            :auto-crop="option.autoCrop"
            :auto-crop-width="option.autoCropWidth"
            :auto-crop-height="option.autoCropHeight"
            :center-box="option.centerBox"
            :high="option.high"
            :max-img-size="option.max"
            :fixed-number="fixedNumber"
            :enlarge="option.enlarge"
            :infoTrue="option.infoTrue"
            :mode="option.mode"
          >
          </vue-cropper>
        </div>
      </div>
    </article>
  </div>
</template>

<script>
import $ from "jquery";
import axios from "axios";
import Dashboard from "@/components/Dashboard.vue";

import myfun from "./../../assets/vuecropper.js";

export default {
  components: {
    Dashboard,
  },
  metaInfo() {
    return {
      title: "基本資料 - 展昭參展商管理系統",
    };
  },

  data() {
    return {
      UserId: "",
      CSRF_Token: "",
      RegNo: "",
      profileList: {},
      emailListArray: [],
      previews: {},
      previewStyle1: {},
      modelSrc: "",
      OImgSrc: "",
      showImg: false,
      lang: "tw",
      LocalExh: true,

      option: {
        img: "", // 裁剪图片的地址V
        max: 9999, //限制图片最大宽度和高度
        enlarge: 1,
        mode: "contain",

        centerBox: false, // 截图框是否被限制在图片里面
        canMove: true, //上传图片是否可以移动
        infoTrue: true,

        fixedBox: true, // 固定截图框大小 不允许改变
        canMoveBox: false, // 截图框能否拖动
        autoCrop: true, // 是否默认生成截图框
        // 只有自动截图开启 宽度高度才生效
        autoCropWidth: 500, // 默认生成截图框宽度
        autoCropHeight: 500,

        full: true, //是否输出原图比例的截图，X匯出等比例(長型就匯長型)
        high: true, //是否按照设备的dpr 输出等比例图片，X匯出等比例(長型就匯長型)
        original: true, // 上传图片按照原始比例渲染

        size: 1, //裁剪生成图片的质量V
        outputType: "png", // 裁剪生成图片的格式V
      },

      fixed: true, // 是否开启截图框宽高固定比例
      fixedNumber: [1, 1], // 截图框的宽高比例

      logoImg: "",
      ExhLogo: "",
      ExhBegin: "",
      ExhEnd: "",
      ExhVenue: "",
      eExhVenue: "",
      linkSource: "",
      OnlineExpolayoutStatus: "",
      PressReleaseStatus: "",
      VideoStatus: "",
      ProductStatus: "",
      BasicinformationStatus: "",

      //判斷儀表板是否有線上展
      HasOnlineExpo: "",
      openOnlineExpo: "",
      showOnlineStatus: false,

      initialLogo: "",
    };
  },

  // metaInfo() {
  //   console.log(5)
  //   return {
  //     title: 'Epiloge - Build your network in your field of interest',
  //     meta: [],
  //   }
  // },
  methods: {
    resetImg() {
      const vm = this;
      vm.modelSrc = vm.OImgSrc;
    },

    updateLogo() {
      const vm = this;
      const url = `/apiExhibitors/Profile/`;

      // console.log(info)

      if (vm.modelSrc == "/images/default.jpg") {
        alert("圖片為必填項目，請重新檢查！");
      } else {
        if (vm.modelSrc == vm.initialLogo) {
          let info2 = {
            CSRF: vm.CSRF_Token,
            Logo: "",
            BrandName: vm.profileList.BrandName,
            eBrandName: vm.profileList.eBrandName,
            RegNo: vm.RegNo,
          };

          axios.post(url, info2).then(function (response) {
            if (vm.linkSource !== "onlineExpo") {
              if (response.data.Code == 200) {
                alert("您已成功修改參展資訊！");
                document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/profile?no=${vm.RegNo}`;
              } else if (
                response.data.Code == 251 ||
                response.data.Code == 500
              ) {
                alert("系統忙碌，請稍後再試！");
                document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/profile?no=${vm.RegNo}`;
              } else if (response.data.Code == 252) {
                document.location.href = `https://www.chanchao.com.tw/`;
              } else if (response.data.Code == 253) {
                alert("「展出品牌」欄位空白！");
              } else if (response.data.Code == 254) {
                alert("圖片檔案上傳錯誤！");
              }
            } else {
              if (response.data.Code == 200) {
                alert("您已成功修改參展資訊，將為您跳轉回線上展覽設定頁！");
                document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/onlineExpo?no=${vm.RegNo}`;
              } else if (
                response.data.Code == 251 ||
                response.data.Code == 500
              ) {
                alert("系統忙碌，請稍後再試！");
                document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/profile?no=${vm.RegNo}`;
              } else if (response.data.Code == 252) {
                document.location.href = `https://www.chanchao.com.tw/`;
              } else if (response.data.Code == 253) {
                alert("「展出品牌」欄位空白！");
              } else if (response.data.Code == 254) {
                alert("圖片檔案上傳錯誤！");
              }
            }
          });
        } else {
          let info2 = {
            CSRF: vm.CSRF_Token,
            Logo: vm.modelSrc,
            BrandName: vm.profileList.BrandName,
            eBrandName: vm.profileList.eBrandName,
            RegNo: vm.RegNo,
          };

          axios.post(url, info2).then(function (response) {
            if (vm.linkSource !== "onlineExpo") {
              if (response.data.Code == 200) {
                alert("您已成功修改參展資訊！");
                document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/profile?no=${vm.RegNo}`;
              } else if (
                response.data.Code == 251 ||
                response.data.Code == 500
              ) {
                alert("系統忙碌，請稍後再試！");
                document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/profile?no=${vm.RegNo}`;
              } else if (response.data.Code == 252) {
                document.location.href = `https://www.chanchao.com.tw/`;
              } else if (response.data.Code == 253) {
                alert("「展出品牌」欄位空白！");
              } else if (response.data.Code == 254) {
                alert("圖片檔案上傳錯誤！");
              }
            } else {
              if (response.data.Code == 200) {
                alert("您已成功修改參展資訊，將為您跳轉回線上展覽設定頁！");
                document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/onlineExpo?no=${vm.RegNo}`;
              } else if (
                response.data.Code == 251 ||
                response.data.Code == 500
              ) {
                alert("系統忙碌，請稍後再試！");
                document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/profile?no=${vm.RegNo}`;
              } else if (response.data.Code == 252) {
                document.location.href = `https://www.chanchao.com.tw/`;
              } else if (response.data.Code == 253) {
                alert("「展出品牌」欄位空白！");
              } else if (response.data.Code == 254) {
                alert("圖片檔案上傳錯誤！");
              }
            }
          });
        }
      }
    },

    uploadNewImgPC(e) {
      const vm = this;
      // alert(vm.option.img)

      if (!/\.(jpg|JPG|jpeg|JPEG|webp|WEBP)$/.test(e.target.value)) {
        if (vm.lang == "tw") {
          alert("上傳檔案類型必須是 JPG, WebP！");
          return false;
        } else {
          alert("Upload file must be in JPG or WebP! ");
          return false;
        }
      } else {
        let file = e.target.files[0];

        let reader = new FileReader();

        reader.onload = (e) => {
          const isLt5M = e.total / 1024 / 1024 < 3;

          if (isLt5M) {
            $("#cropImagePop").modal("show");

            $("#cropImagePop").on("shown.bs.modal", function () {
              vm.option.img = window.URL.createObjectURL(
                new Blob([e.target.result]),
              );
              // alert(vm.option.img)
            });
          } else {
            if (vm.lang == "tw") {
              alert("上傳圖片大小請勿超過 3MB！");
            } else {
              alert("Maximum file size : 3MB");
            }
          }
        };

        reader.readAsArrayBuffer(file);
        e.target.value = "";
      }
    },

    uploadNewImgMb(e) {
      const vm = this;

      //上传图片
      // this.option.img
      let file = e.target.files[0];
      if (!/\.(jpg|JPG|jpeg|JPEG|webp|WEBP)$/.test(e.target.value)) {
        if (vm.lang == "tw") {
          alert("上傳檔案類型必須是 JPG, WebP！");
          return false;
        } else {
          alert("Upload file must be in JPG or WebP! ");
          return false;
        }
      }
      let reader = new FileReader();
      reader.readAsArrayBuffer(file);

      reader.onload = (e) => {
        const isLt5M = e.total / 1024 / 1024 < 3;

        if (isLt5M) {
          this.option.img = window.URL.createObjectURL(
            new Blob([e.target.result]),
          );
          vm.showImg = true;
          $("#cropperMb").modal("show");
        } else {
          if (vm.lang == "tw") {
            alert("上傳圖片大小請勿超過 3MB！");
          } else {
            alert("Maximum file size : 3MB");
          }
        }
      };
      e.target.value = "";
    },

    OutputPC() {
      const vm = this;

      this.$refs.cropper.getCropData((data) => {
        // console.log(data)
        this.modelSrc = data;

        $("#cropImagePop").modal("hide");

        $("#cropImagePop").on("hidden.bs.modal", function (e) {
          vm.option.img = "/";
        });
      });
    },

    OutputMb() {
      // 输出
      const vm = this;

      this.$refs.cropper.getCropData((data) => {
        // console.log(data)
        this.modelSrc = data;
      });

      $("#cropperMb").modal("hide");
      vm.showImg = false;
    },

    realTime(data) {
      var previews = data;
      var h = 0.5;
      var w = 0.2;

      this.previewStyle1 = {
        width: previews.w + "px",
        height: previews.h + "px",
        overflow: "hidden",
        margin: "0",
        zoom: h,
      };
      this.previews = data;
    },

    rotateLeft() {
      this.$refs.cropper.rotateLeft();
    },
    rotateRight() {
      this.$refs.cropper.rotateRight();
    },

    changeScale(num) {
      num = num || 1;
      this.$refs.cropper.changeScale(num);
    },

    refreshCrop() {
      this.$refs.cropper.refresh();
    },
  },

  created() {
    const vm = this;

    //取得語系

    //CSRF_Token
    axios
      .get("https://www.chanchao.com.tw/apiExhibitors/CSRF_Token")
      .then((response) => {
        vm.CSRF_Token = response.data;
      });

    axios
      .get(`https://www.chanchao.com.tw/apiExhibitors/UserID`)
      .then((response) => {
        vm.UserId = response.data;
      });

    //url取出展碼
    let nowPage = location.href;
    vm.RegNo = nowPage.split("no=")[1];

    let hasPagenum = new URL(nowPage);
    vm.linkSource = hasPagenum.searchParams.get("source");

    //取得當前時間
    let theDate = new Date();
    vm.date = `${theDate.getFullYear()}/${
      theDate.getMonth() + 1
    }/${theDate.getDate()}`;

    axios
      .get(`https://www.chanchao.com.tw/apiExhibitors/Exhibitor/${vm.RegNo}`)
      .then((response) => {
        vm.profileList = response.data.Data;

        //取得是否填寫狀態盤的值

        vm.OnlineExpolayoutStatus = response.data.Data.OnlineExpolayoutStatus;
        vm.PressReleaseStatus = response.data.Data.PressReleaseStatus;
        vm.VideoStatus = response.data.Data.VideoStatus;
        vm.ProductStatus = response.data.Data.ProductStatus;
        vm.BasicinformationStatus = response.data.Data.BasicinformationStatus;

        if (response.data.Data.Logo) {
          vm.modelSrc = `//www.chanchao.com.tw/exhibitorservicefiles/logo/${response.data.Data.Logo}`;
          vm.OImgSrc = `//www.chanchao.com.tw/exhibitorservicefiles/logo/${response.data.Data.Logo}`;
          vm.initialLogo = `//www.chanchao.com.tw/exhibitorservicefiles/logo/${response.data.Data.Logo}`;
        } else {
          vm.modelSrc = `/images/default.jpg`;
          vm.OImgSrc = `/images/default.jpg`;
          vm.initialLogo = `/images/default.jpg`;
        }

        vm.HasOnlineExpo = response.data.Data.Virtual;

        //取得是否開啟線上展權限
        axios
          .get(
            `https://www.chanchao.com.tw/apiExhibitors/Exhibition/${vm.RegNo}?lang=${vm.lang}`,
          )
          .then((response) => {
            // console.log(response.data)

            vm.ExhLogo = `//www.ccie.com.tw/exhibition/images/exlogo/${response.data.Data.ExhLogo}`;
            vm.ExhBegin = response.data.Data.ExhBegin;
            vm.ExhEnd = response.data.Data.ExhEnd;
            vm.ExhVenue = response.data.Data.ExhVenue;
            vm.eExhVenue = response.data.Data.eExhVenue;

            vm.openOnlineExpo = response.data.Data.OnlineExpo_Archived;

            if (ExpoLocation === "T" || ExpoLocation === null) {
              vm.LocalExh = true;
            } else {
              vm.LocalExh = false;
            }

            if (vm.openOnlineExpo == 1 && vm.HasOnlineExpo == 1) {
              vm.showOnlineStatus = true;
            } else {
              vm.showOnlineStatus = false;
            }
          });
      });
  },
};
</script>

<style lang="scss">
.uncomplete {
  background-image: url("../../assets/images/tickGray.svg");
  width: 18px;
  height: 18px;
  display: inline-block;
  background-repeat: no-repeat;
  background-position: left center;
  background-size: auto 100%;
  padding-left: 20px;
}

.complete {
  background-image: url("../../assets/images/tick.svg");
  width: 18px;
  height: 18px;
  display: inline-block;
  background-repeat: no-repeat;
  background-position: left center;
  background-size: auto 100%;
  padding-left: 20px;
}

.btn {
  border-radius: 5px;
}

.cropViewFrame {
  border: 1px solid rgb(210, 228, 238);
}

.formContent {
  font-weight: 550;
  font-size: 15px;
}

@media screen and (min-width: 331px) and (max-width: 576px) {
  .modal-content {
    width: 65%;
  }
}

@media screen and (max-width: 330px) {
  .modal-content {
    width: 60%;
  }
}

.modal-xl {
  max-width: 940px;
}
</style>
